import { create } from 'zustand';
import { db, auth } from '../lib/firebase';
import { doc, onSnapshot } from 'firebase/firestore';

const useConfigStore = create((set, get) => ({
    aiConfigs: { defaultConfigId: null, configs: {} },
    loading: true,
    error: null,
    unsubscribeConfigs: null,

    subscribeToConfigs: () => {
        const user = auth.currentUser;
        if (!user) {
            set({ loading: false });
            return;
        }

        // Cleanup old listener
        const oldUnsub = get().unsubscribeConfigs;
        if (oldUnsub) oldUnsub();

        const configRef = doc(db, 'users', user.uid, 'settings', 'ai_configs');

        const unsubscribe = onSnapshot(configRef, (snapshot) => {
            if (snapshot.exists()) {
                set({ aiConfigs: snapshot.data(), loading: false });
            } else {
                set({ aiConfigs: { defaultConfigId: null, configs: {} }, loading: false });
            }
        }, (err) => {
            console.error("AI Configs subscription error:", err);
            set({ error: err.message, loading: false });
        });

        set({ unsubscribeConfigs: unsubscribe });
        return unsubscribe;
    },

    getConfig: (configId) => {
        const configs = get().aiConfigs?.configs || {};
        return configs[configId] || null;
    },

    getDefaultConfig: () => {
        const { aiConfigs } = get();
        if (!aiConfigs?.defaultConfigId) return null;
        return aiConfigs.configs[aiConfigs.defaultConfigId] || null;
    }
}));

export default useConfigStore;
